export default __webpack_public_path__ + "static/media/camera.d1165aff.svg";